import { render, staticRenderFns } from "./PayBilling.vue?vue&type=template&id=5745ca9a&scoped=true"
import script from "./PayBilling.vue?vue&type=script&lang=js"
export * from "./PayBilling.vue?vue&type=script&lang=js"
import style0 from "./PayBilling.vue?vue&type=style&index=0&id=5745ca9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5745ca9a",
  null
  
)

export default component.exports